import NominationHistory from "../history";
import Slider from "shared/components/slider";
import useCreateOrgAdminService from "./service";
import { useCopies } from "shared/hooks/useCopies";
import OrgAdminForm from "./components/orgAdminForm";

export default function CreateOrgAdmin() {
  const copies = useCopies();
  const service = useCreateOrgAdminService();
  if (!service.orgAdminFormLoaded) {
    return null;
  }
  return (
    <Slider
      title={service.isCreateMode ? copies.get("create.org.admin") : copies.get("assign.org.admin")}
      handleClose={service.closeHandler}>
      <NominationHistory applicantId={service.registrationParticipantId} participantName={service.participantName} />
      {service.orgAdminForm?.profile && <OrgAdminForm service={service} />}
    </Slider>
  );
}
